/*
 * @Description: event bus
 * @Author: zhongshanxian01
 * @Date: 2021-09-09 10:57:35
 * @LastEditors: zhongshanxian01
 * @LastEditTime: 2021-10-21 18:06:04
 */
import EventEmitter from 'eventemitter3';

export const evtBus = new EventEmitter();
export const emit = evtBus.emit.bind(evtBus);
export const on = evtBus.on.bind(evtBus);
export const once = evtBus.once.bind(evtBus);
export const off = evtBus.off.bind(evtBus);

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
